import React, { useContext, useState } from 'react'
import { ThemeContext } from '../../../auth';
import axios from '../../../api/axios';
import Swal from 'sweetalert2';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';

function ModalDivisi({
    showModal,
    setShowModal,
    tokenUser,
    retrieveDivisi,
    rowSelected,
    mode,
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowModal(false);
    };

    const defaultValue = {
        name: rowSelected?.name || "",
    };

    const handleSubmitAdd = async (values) => {
        setIsSubmitting(true);
        setDisabled(true);

        const data = {
            name: values?.name
        };

        try {

            const response = await axios.post(`/account/division/`, data, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    withCredentials: true,
                    Authorization: `Token ${tokenUser}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: "success",
                title: "Berhasil menambahkan Divisi",
                showConfirmButton: true,
            });

            retrieveDivisi();

            setIsSubmitting(false);
            setDisabled(false);
        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan saat menambahkan Divisi",
            });

            setIsSubmitting(false);
            setDisabled(false);
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    const handleSubmitEdit = async (values) => {
        setIsSubmitting(true);
        setDisabled(true);

        const dataGroup = {
            name: values?.name
        };

        try {
            await axios.patch(`/account/division/${rowSelected?.id}/`, dataGroup, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    withCredentials: true,
                    Authorization: `Token ${tokenUser}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: "success",
                title: "Berhasil mengubah Divisi",
                showConfirmButton: true,
            });

            retrieveDivisi();

            setIsSubmitting(false);
            setDisabled(false);
        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan saat mengubah Divisi",
            });

            setIsSubmitting(false);
            setDisabled(false);
        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    const handleSubmit = async (values) => {
        if (mode === "Tambah") {
            handleSubmitAdd(values);
        } else if (mode === "Ubah") {
            handleSubmitEdit(values);
        }
    };

    const formStyles = {
        label: {
            fontFamily: "Poppins-Medium",
            color: theme === "light" ? "#FFFFFF" : "#222222",
        },
        input: {
            color: theme === "light" ? "#FFFFFF" : "#222222",
            fontFamily: "Poppins-Regular",
            minHeight: "50px",
            borderColor: "#ced4da",
        },
    };

    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === "light" ? "dark" : ""}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: "Poppins-Medium", color: theme === "light" ? "#FFFFFF" : "#222222", }}>
                    {mode} Divisi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmit}
                >
                    {({
                        handleSubmit,
                        values,
                        setFieldValue
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor="divisi">Nama Divisi*</Form.Label>
                                <Form.Control
                                    id="divisi"
                                    type="text"
                                    value={values.name}
                                    onChange={(e) => {
                                        const capitalizedValue = e.target.value
                                            .toLowerCase()
                                            .replace(/\b\w/g, (char) => char.toUpperCase());
                                        setFieldValue("name", capitalizedValue);
                                    }}
                                    style={formStyles.input}
                                    placeholder='Masukkan nama divisi'
                                />
                            </Form.Group>
                            {/* <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor="budget">Anggaran*</Form.Label>
                                <Form.Control
                                    id='budget'
                                    type='text'
                                    value={values.budget ? formatToIDR(values.budget) : "Rp 0,00"}
                                    onChange={(e) => handlePriceChange(e, setFieldValue)}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group> */}
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={
                                            theme === "light"
                                                ? "actionButtonModalDark"
                                                : "actionButtonModalLight"
                                        }
                                        variant="btn"
                                        disabled
                                    >
                                        <Spinner animation="border" size="sm" />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={
                                            theme === "light"
                                                ? "actionButtonModalDark"
                                                : "actionButtonModalLight"
                                        }
                                        variant="btn"
                                        disabled={disabled || !values?.name}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalDivisi
